import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiDeleteRequestTicketRequest extends ApiRequestor {
  async $deleteTicketRequest(ticketRequestIds, organizationId) {
    const payload = {ticketRequestIds, organizationId};
    return this.$http('DELETE', 'ticketRequests/', {payload});
  }
}
